import MotorModal from './motor-modal';

export default MotorModal;
